import server from "../apis/server";
import { push } from "connected-react-router";
import { ROOT_PATH } from "../routing/paths";
import showNotification from "./showNotification";
import { AppDispatch } from "../redux/types";

const request = (method: string, endpoint: string, params: unknown) => {
  if (method === "get") return server.get(endpoint, { params });
  if (method === "put") return server.put(endpoint, params);
  return server.post(endpoint, params);
};

export default async (
  method: string,
  endpoint: string,
  onSuccess: (arg0: any) => void,
  dispatch: AppDispatch,
  params: unknown = {},
): Promise<void> => {
  const response = await request(method, endpoint, params);
  if (response === undefined) {
    showNotification("We had an issue connecting to server. Please try again", "info");
  } else {
    const { success, data, error, status } = response.data;
    if (success) onSuccess(data);
    else
      switch (status) {
        case 401:
          localStorage.removeItem("token");
          dispatch(push(ROOT_PATH));
          showNotification(error, "warning");
          break;
        case 400:
          showNotification(error, "error");
          break;
      }
  }
};
